import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

export interface TabItem {
  label: string;
  count: number;
  isSelected: boolean;
  key: string;
}

@Component({
  selector: 'app-flag-resolve-topbar',
  templateUrl: './flag-resolve-topbar.component.html',
  styleUrls: ['./flag-resolve-topbar.component.scss'],
})
export class FlagResolveTopbarComponent implements OnInit, OnChanges {
  @Input() totalFlags: number = 8;
  @Input() resolvedFlags: number = 4;
  @Input() unresolvedCount: number = 4;
  @Input() partialResponseCount: number = 4;
  @Input() selectedTab: string = 'unresolved';

  @Input() resolveBarSelectedTab: string = 'unresolved';

  @Output() tabChange = new EventEmitter<string>();

  tabs: TabItem[] = [
    { label: 'Unresolved', count: 0, isSelected: true, key: 'unresolved' },
    { label: 'Partial response', count: 0, isSelected: false, key: 'partial' },
  ];

  get progressPercentage(): number {
    return this.totalFlags > 0 ? Math.round((this.resolvedFlags / this.totalFlags) * 100) : 0;
  }

  get progressBarWidth(): string {
    return `${this.progressPercentage}%`;
  }

  onTabClick(tabKey: string): void {
    const targetTab = this.tabs.find(tab => tab.key === tabKey);
    if (targetTab && targetTab.count > 0) {
      this.selectedTab = tabKey;
      this.updateSelectedTab();
      this.tabChange.emit(tabKey);
    } else {
      console.log('Cannot select tab with 0 flags:', tabKey);
    }
  }

  ngOnInit(): void {
    this.updateTabCounts();
    setTimeout(() => {
      this.selectBestAvailableTab();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resolveBarSelectedTab']) {
      this.selectedTab = this.resolveBarSelectedTab;
      this.updateSelectedTab();
    }

    if (changes['unresolvedCount'] || changes['partialResponseCount']) {
      this.updateTabCounts();
      setTimeout(() => {
        this.checkAndSwitchToAvailableTab();
      });
    }

    if (changes['selectedTab']) {
      this.updateSelectedTab();
    }
  }

  private updateTabCounts(): void {
    this.tabs[0].count = this.unresolvedCount;
    this.tabs[1].count = this.partialResponseCount;
  }

  private selectBestAvailableTab(): void {
    if (this.unresolvedCount > 0) {
      this.selectedTab = 'unresolved';
    } else if (this.partialResponseCount > 0) {
      this.selectedTab = 'partial';
    } else {
      this.selectedTab = 'unresolved';
    }
    this.updateSelectedTab();
    this.tabChange.emit(this.selectedTab);
  }

  private checkAndSwitchToAvailableTab(): void {
    setTimeout(() => {
      if (this.selectedTab === 'unresolved' && this.unresolvedCount === 0 && this.partialResponseCount > 0) {
        this.selectedTab = 'partial';
        this.tabChange.emit('partial');
      } else if (this.selectedTab === 'partial' && this.partialResponseCount === 0 && this.unresolvedCount > 0) {
        this.selectedTab = 'unresolved';
        this.tabChange.emit('unresolved');
      }
    });
  }

  private updateSelectedTab(): void {
    this.tabs.forEach(tab => {
      tab.isSelected = tab.key === this.selectedTab;
    });
  }
}
